import React from 'react';
import { CheckSquare, Square } from 'lucide-react';

const MultipleChoice = ({ options = [], value = [], onChange, subQuestionText, extraText, onExtraTextChange, disabled }) => {
  const parsedOptions = typeof options === 'string' ? JSON.parse(options) : options;
  const currentValues = Array.isArray(value) ? value : (value ? [value] : []);

  const toggleOption = (opt) => {
    if (currentValues.includes(opt)) {
      onChange(currentValues.filter(item => item !== opt));
    } else {
      onChange([...currentValues, opt]);
    }
  };

  return (
    <div className="flex flex-col gap-3 w-full py-2">
      {parsedOptions.map((opt, idx) => {
        const isSelected = currentValues.includes(opt);
        return (
          <button
            key={idx}
            type="button"
            disabled={disabled}
            onClick={() => toggleOption(opt)}
            className={`w-full p-4 rounded-xl border-2 text-left font-medium transition-all duration-200 flex items-center justify-between cursor-pointer ${
              isSelected
                ? 'border-blue-600 bg-blue-50/70 text-blue-950 shadow-md'
                : 'border-slate-200 bg-white text-slate-700 hover:border-blue-300 hover:bg-blue-50/30'
            }`}
          >
            <span className="text-sm sm:text-base">{opt}</span>
            <div className={`transition-colors ${isSelected ? 'text-blue-600' : 'text-slate-300'}`}>
              {isSelected ? <CheckSquare className="w-6 h-6 fill-blue-600 text-white" /> : <Square className="w-6 h-6" />}
            </div>
          </button>
        );
      })}

      {subQuestionText && currentValues.length > 0 && (
        <div className="mt-3 p-4 bg-slate-50 border border-slate-200 rounded-xl animate-fadeIn">
          <label className="block text-sm font-semibold text-slate-700 mb-2">
            {subQuestionText}
          </label>
          <input
            type="text"
            value={extraText || ''}
            onChange={(e) => onExtraTextChange(e.target.value)}
            disabled={disabled}
            placeholder="Escribe aquí tu respuesta..."
            className="w-full p-3 bg-white border border-slate-300 rounded-lg text-slate-800 text-sm focus:outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600"
          />
        </div>
      )}
    </div>
  );
};

export default MultipleChoice;
